import { CuratorID } from '@/features/vaults/types/CuratorID';

import { Curator } from './types';

export const curators: Partial<Record<CuratorID, Curator>> = {
  steakhouse: {
    id: 'steakhouse',
    name: 'Steakhouse',
    href: 'https://www.steakhouse.financial',
  },
  re7labs: {
    id: 're7labs',
    name: 'Re7 Labs',
    href: 'https://re7.capital',
  },
  mevcapital: {
    id: 'mevcapital',
    name: 'MEV Capital',
    href: 'https://mevcapital.com',
  },
  p2p: {
    id: 'p2p',
    name: 'P2P',
    href: 'https://p2p.org',
  },
  renzo: {
    id: 'renzo',
    name: 'Renzo',
    href: 'https://www.renzoprotocol.com',
  },
  quasar: {
    id: 'quasar',
    name: 'Quasar',
    href: 'https://quasar.fi',
  },
  infStones: {
    id: 'infStones',
    name: 'InfStones',
    href: 'https://infstones.com',
  },
  luganodes: {
    id: 'luganodes',
    name: 'LugaNodes',
    href: 'https://www.luganodes.com',
  },
  chorusone: {
    id: 'chorusone',
    name: 'Chorus One',
    href: 'https://chorus.one',
  },
  rockx: {
    id: 'rockx',
    name: 'RockX',
    href: 'https://www.rockx.com',
  },
  hashkey: {
    id: 'hashkey',
    name: 'HashKey',
    href: 'https://www.hashkey.cloud',
  },
  infrasingularity: {
    id: 'infrasingularity',
    name: 'InfraSingularity',
    href: 'https://infrasingularity.com',
  },
  a41: {
    id: 'a41',
    name: 'A41',
    href: 'https://www.a41.io',
  },
  gauntlet: {
    id: 'gauntlet',
    name: 'Gauntlet',
    href: 'https://www.gauntlet.xyz',
  },
  stakefish: {
    id: 'stakefish',
    name: 'Stakefish',
    href: 'https://stake.fish',
  },
  stakecapital: {
    id: 'stakecapital',
    name: 'Stake Capital',
    href: 'https://www.stake.capital',
  },
  'nodes.guru': {
    id: 'nodes.guru',
    name: 'Nodes.Guru',
    href: 'https://nodes.guru',
  },
  proviroll: {
    id: 'proviroll',
    name: 'Proviroll',
    href: 'https://www.proviroll.io',
  },
  cosmostation: {
    id: 'cosmostation',
    name: 'Cosmostation',
    href: 'https://cosmostation.io',
  },
  dsrv: {
    id: 'dsrv',
    name: 'DSRV',
    href: 'https://dsrv.com',
  },
  republic: {
    id: 'republic',
    name: 'Republic',
    href: 'https://republic.com',
  },
  cp0x: {
    id: 'cp0x',
    name: 'cp0x',
    href: 'https://cp0x.com',
  },
  hyve: {
    id: 'hyve',
    name: 'Hyve',
    href: 'https://hyveda.xyz',
  },
  nexo: {
    id: 'nexo',
    name: 'K3 Capital',
    href: 'https://k3.capital',
  },
  ibtc: {
    id: 'ibtc',
    name: 'iBTC',
    href: 'https://www.ibtc.network',
  },
  theoriq: {
    id: 'theoriq',
    name: 'Theoriq',
    href: 'https://www.theoriq.ai',
  },
  mezo: {
    id: 'mezo',
    name: 'Mezo',
    href: 'https://mezo.org',
  },
  sense: {
    id: 'sense',
    name: 'Sense.capital',
    href: 'https://sense.capital/',
  },
  tyr: {
    id: 'tyr',
    name: 'tyr.capital',
    href: 'https://www.tyr.capital/',
  },
};
